import React from 'react';
import PropTypes from 'prop-types';

import { PLUGIN_TYPES } from '../../../constants/plugin-types';
import { PluginCarouselIcon, PluginListIcon, PluginGalleryIcon, PluginPlaylistIcon } from '../..';

export const VpPluginTypeIcon = ({ type, ...rest }) => {
  const pluginIconTypes = {
    [PLUGIN_TYPES.CAROUSEL]: PluginCarouselIcon,
    [PLUGIN_TYPES.GALLERY]: PluginGalleryIcon,
    [PLUGIN_TYPES.PLAYLIST]: PluginPlaylistIcon,
    [PLUGIN_TYPES.LIST]: PluginListIcon
  };
  const IconComponent = pluginIconTypes[type] || PluginCarouselIcon;

  return <IconComponent {...rest} />;
};

VpPluginTypeIcon.propTypes = {
  type: PropTypes.string
};

export default VpPluginTypeIcon;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPluginTypeIcon/VpPluginTypeIcon.jsx